@if (assemblyOrder) {
  <div class="container-scroll-wrapper w-100">
    <div
      class="container w-100 p-0 border-4"
      [ngClass]="getOrderStatus(assemblyOrder.statusId)"
      #contentToPrint
      >
      <!-- Header Section -->
      <div class="custom-row initial-row" style="border: solid 3px #bfbfc0">
        <mat-icon
          class="chevron"
          (click)="toggleScheduleTaskExpansion(); getScheduleTaskLogs()"
          (keydown.enter)="toggleScheduleTaskExpansion()"
          >{{ scheduleTaskExpanded ? "expand_more" : "chevron_right" }}</mat-icon
          >
          <div class="w-100">
            <span
              class="justify-content-center text-center schedule-date"
              [class.offest-left]="usrSvc.hasPermission('edit:aopayment')"
              >{{ assemblyOrder.scheduleDate | date: "EEEE MMM d y" }}</span
              >
            </div>
            <div class="col-1">
              <app-icon-menu-button
                class="header-menu-trigger"
                [menu]="menu"
              ></app-icon-menu-button>
              <mat-menu #menu="matMenu">
                <button
                  mat-menu-item
            (click)="
              enableDisable(!assemblyOrder.paid, assemblyOrder.id.toString())
            "
                  *appHideIfNoPermission="'edit:aopayment'"
                  >
                  <mat-icon>{{
                    !assemblyOrder.paid ? "toggle_on" : "toggle_off"
                  }}</mat-icon>
                  <span>{{
                    !assemblyOrder.paid ? "Habilitar" : "Deshabilitar"
                  }}</span>
                </button>
                @if (assemblyOrder.paid) {
                  <button mat-menu-item (click)="printPDF()">
                    <mat-icon>print</mat-icon>
                    <span>Imprimir</span>
                  </button>
                  <mat-divider *appHideIfNoPermission="'add:aotask'"></mat-divider>
                  <button
                    mat-menu-item
                    (click)="openAddTaskModal()"
                    *appHideIfNoPermission="'add:aotask'"
                    >
                    <mat-icon>add</mat-icon>
                    <span>Agregar ítem</span>
                  </button>
                }
              </mat-menu>
            </div>
          </div>
          @if (scheduleTaskExpanded) {
            <div
              class="logs-container w-100 p-0 m-0"
              [ngClass]="{ expanded: scheduleTaskExpanded }"
              >
              <div class="log-row p-0 m-0">
                <div class="p-0 m-0">
                  @if (scheduleTaskLogs.length) {
                    <div>
                      <ul class="ps-0 schedule-task-logs">
                        @for (log of scheduleTaskLogs; track log; let i = $index) {
                          <li
                            class="log-event p-0 m-0"
                            >
                            <div class="text-left">
                              <span class="log-cell-text">
                                {{ log.changeReason }}
                              </span>
                            </div>
                            <div class="text-left">
                              <span class="log-cell-text">
                                {{ log.changedBy }}
                              </span>
                            </div>
                            <div class="text-left">
                              <span class="log-cell-text">
                                {{ i == 0 ? "Fecha actual:" : "" }}
                                {{ log.newScheduleDate | date: "dd/MM/yyyy - HH:mm" }}
                              </span>
                            </div>
                            <div class="text-left">
                              <span class="log-cell-text">
                                {{ i == 0 ? "Fecha anterior:" : "" }}
                                {{ log.oldScheduleDate | date: "dd/MM/yyyy - HH:mm" }}
                              </span>
                            </div>
                          </li>
                        }
                      </ul>
                    </div>
                  } @else {
                    @if (!scheduleTaskLogs.length) {
                      <div class="loader"></div>
                    }
                  }
                </div>
              </div>
            </div>
          }
          <div
            class="custom-row border-2 initial-row"
            [ngClass]="getPoolStatus(assemblyOrder.poolShell.statusId)"
      [ngStyle]="{
        'z-index':
          assemblyOrder.statusId == _assemblyOrderEnum.Bloqueada ? 503 : 'auto',
      }"
            >
            <div class="d-flex justify-content-center w-100">
              <div
                class="col text-center"
          (click)="
            togglePoolshellExpansion();
            getPoolShellLogs(assemblyOrder.poolShell)
          "
                (keydown.enter)="getPoolShellLogs(assemblyOrder.poolShell)"
                >
                <mat-icon class="chevron" style="margin-right: 5px">{{
                  assemblyOrder.poolShell.expanded ? "expand_more" : "chevron_right"
                }}</mat-icon>
                <div class="pool-shell-position">
                  {{ assemblyOrder.productName }}
                  {{
                  assemblyOrder.productQuality == "Primera"
                  ? ""
                  : assemblyOrder.productQuality + " - "
                  }}
                  {{ assemblyOrder.warrantyNumber }}
                </div>
              </div>
            </div>
            <div class="icon-container">
              <app-state-switcher
                [itemId]="assemblyOrder.poolShell.id"
                [startingState]="assemblyOrder.poolShell.statusId"
                [description]="assemblyOrder.productName"
                [onStateChangedFunction]="poolShellStatusChanger"
                [states]="poolStates"
          (statusChangedResult)="
            assemblyOrder.poolShell.statusId = $event; onChangedOrderState()
          "
                [disabled]="getPoolShellDisabledState()"
                >
              </app-state-switcher>
            </div>
            <div
              class="icon-container-2"
              [class.disable]="assemblyOrder.statusId == _assemblyOrderEnum.Bloqueada"
              >
              <app-in-transit [assemblyOrder]="assemblyOrder"></app-in-transit>
            </div>
          </div>
          <!-- Logs de Pool Shell -->
          @if (assemblyOrder.poolShell.expanded) {
            <div
              class="logs-container w-100 p-0 m-0"
              [ngClass]="{ expanded: assemblyOrder.poolShell.expanded }"
              >
              <div class="log-row p-0 m-0">
                <div class="col p-0 m-0">
                  @if (assemblyOrder.poolShell.logs?.length) {
                    <div>
                      <ul class="ps-0">
                        @for (log of assemblyOrder.poolShell.logs; track log) {
                          <li
                            class="log-event row p-0 m-0"
                            >
                            <div class="col text-left">
                              <span class="log-cell-text">{{
                                log.createdOn | date: "dd/MM/yyyy - HH:mm"
                              }}</span>
                            </div>
                            <div class="col">
                              <span class="log-cell-text">{{ log.status }}</span>
                            </div>
                            <div class="col">
                              <span class="log-cell-text">{{ log.userName }}</span>
                            </div>
                          </li>
                        }
                      </ul>
                    </div>
                  } @else {
                    @if (!assemblyOrder.poolShell.logs) {
                      <div class="loader"></div>
                    }
                  }
                  @if (
                    assemblyOrder.poolShell.logs &&
                    assemblyOrder.poolShell.logs!.length == 0
                    ) {
                    <div
                      class="py-3"
                      >
                      <span class="col"
                        >No se encontraron logs para el producto seleccionado.</span
                        >
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
            <div
              class="custom-row border-2 initial-row"
              [ngClass]="assemblyOrder.productColorName.toLocaleLowerCase()"
              >
              <div class="col text-center">{{ assemblyOrder.productColorName }}</div>
            </div>
            <div class="custom-row border-2 initial-row">
              <div class="col text-center">{{ assemblyOrder.clientCity }}</div>
            </div>
            <div class="custom-row border-2 initial-row">
              <div class="col text-center">
                {{ assemblyOrder.clientName }} - {{ assemblyOrder.pointOfSale }}
              </div>
            </div>
            <!-- Types Section -->
            @for (task of assemblyOrder.assemblyTasks; track task; let i = $index) {
              <div class="products-row align-items-center m-0 p-0">
                <!-- Type Column -->
                <div
                  class="border-1 product-type-col col-3 d-flex align-items-center justify-content-left h-100 ps-3"
                  >
                  {{ task.alias }}
                </div>
                <!-- Description Column -->
                <div
                  class="product-expand-col border-1 col-9 d-flex align-items-center justify-content-between h-100 ps-2"
                  [ngClass]="getProdStatus(task.statusId)"
                  (click)="getLogs(task); toggleTaskExpansion(i)"
                  (keydown.enter)="getLogs(task); toggleTaskExpansion(i)"
                  >
                  <div class="d-flex align-items-center">
                    <mat-icon>{{
                      i === expandedIndex ? "expand_more" : "chevron_right"
                    }}</mat-icon>
                    {{ task.description }}
                  </div>
                  @if (task.statusId !== _productStatusEnum.Lista) {
                    <app-icon-menu-button
                      class="task-menu-trigger"
                      *appHideIfNoPermission="['edit:aotask', 'delete:aotask']"
                      [menu]="menuTask"
                      (click)="$event.stopPropagation()"
                      (keydown.enter)="$event.stopPropagation()"
                    ></app-icon-menu-button>
                  }
                  <app-state-switcher
                    class="task-state-switcher"
                    [itemId]="task.id"
                    [startingState]="task.statusId"
                    [description]="task.description"
                    [onStateChangedFunction]="itemStatusChanger"
            (statusChangedResult)="
              task.statusId = $event; onChangedOrderState()
            "
                    [disabled]="getAssemblyTaskDisabledState(task.permissions)"
                    >
                  </app-state-switcher>
                  <mat-menu #menuTask="matMenu">
                    <button
                      mat-menu-item
                      (click)="openEditTaskModal(task)"
                      *appHideIfNoPermission="'edit:aotask'"
                      >
                      <mat-icon>edit</mat-icon>
                      <span>Editar</span>
                    </button>
                    <button
                      mat-menu-item
                      class="delete-menu-item"
                      (click)="deleteTask(task)"
                      *appHideIfNoPermission="'delete:aotask'"
                      >
                      <mat-icon>delete_outline</mat-icon>
                      <span>Eliminar</span>
                    </button>
                  </mat-menu>
                </div>
              </div>
              <!-- History (when expanded) -->
              @if (i === expandedIndex) {
                <div
                  class="logs-container w-100 p-0 m-0"
                  [ngClass]="{ expanded: i === expandedIndex }"
                  >
                  <div class="log-row p-0 m-0">
                    <div class="col p-0 m-0">
                      @if (task.logs?.length) {
                        <div class="offset-3">
                          <ul class="ps-0">
                            @for (log of task.logs; track log) {
                              <li class="log-event row p-0 m-0">
                                <div class="col text-left">
                                  <span class="log-cell-text">{{
                                    log.createdOn | date: "dd/MM/yyyy - HH:mm"
                                  }}</span>
                                </div>
                                <div class="col">
                                  <span class="log-cell-text">{{ log.status }}</span>
                                </div>
                                <div class="col">
                                  <span class="log-cell-text">{{ log.userName }}</span>
                                </div>
                                @if (log.description) {
                                  <div class="col">
                                    <span class="log-cell-text">{{ log.description }}</span>
                                  </div>
                                }
                              </li>
                            }
                          </ul>
                        </div>
                      } @else {
                        @if (!task.logs) {
                          <div class="loader"></div>
                        }
                      }
                      @if (task.logs && task.logs!.length == 0) {
                        <div class="py-3">
                          <span class="col"
                            >No se encontraron logs para el producto seleccionado.</span
                            >
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              }
              <div
                class="custom-row end-row d-flex align-items-center justify-content-center border-2"
                >
                @if (!obsEdit) {
                  <div class="text-center w-90 ps-2 comment">
                    <p>{{ assemblyOrder.observations }}</p>
                  </div>
                }
                @if (obsEdit) {
                  <div class="w-80 comment">
                    <textarea
                      class="w-90 text-center"
                      rows="2"
                      [(ngModel)]="observations"
                      style="font-weight: bold"
                    ></textarea>
                  </div>
                }
                @if (obsEdit) {
                  <div
                    class="d-flex m-auto save-observations"
                    (click)="updateObservations()"
                    (keydown.enter)="updateObservations()"
                    >
                    <mat-icon style="color: #14385c">task_alt</mat-icon>
                  </div>
                }
                @if (!obsEdit) {
                  <app-icon-menu-button
                    class="task-menu-trigger"
                    *appHideIfNoPermission="'edit:aoobservation'"
                    [menu]="menuComments"
                  ></app-icon-menu-button>
                }
                <mat-menu #menuComments>
                  <button mat-menu-item (click)="observationsEnable()">Editar</button>
                </mat-menu>
                <mat-icon class="last-icon" [ngClass]="{ ready: isOrderFinished }"
                  >check_circle</mat-icon
                  >
                </div>
                @if (assemblyOrder.statusId == _assemblyOrderEnum.Bloqueada) {
                  <div
                    class="order-blocked-ovelay h-100 p-0"
                  ></div>
                }
                @if (assemblyOrder.statusId == _assemblyOrderEnum.Cancelada) {
                  <div
                    class="order-cancelled-ovelay w-100 h-100 p-0"
                  ></div>
                }
              </div>
            </div>
          }
